import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {format as stringFormat} from 'react-string-format';

import Toast from '../commons/helpers/toast';
import ModalWindow from '../commons/helpers/modalWindow';  

import {formValid} from '../../utils/validation';  
import {titleCase} from '../../utils/changeCase'; 
import {getSortClass} from '../../utils/commonUtilities'; 
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';

import {rolesListAction, rolesAddAction,  rolesUpdateAction, rolesDeleteAction, rolesPermissionEditAction, rolesPermissionUpdateAction} from '../../actions/rolesPermissionsAction';  // rolesEditAction
import {clearAction} from '../../actions/commonActions';

import {ROUTE_SA_SETTINGS, ROUTE_AFFILIATE_SETTINGS} from '../../configs/staticConfigs';
import {LBL_ROLE_PERMISSIONS_SETTINGS,LBL_APP_NAME, LBL_SETTINGS, LBL_ROLE, LBL_ROLES, LBL_SET_PERMISSIONS, LBL_ACTIONS, LBL_SLNUM, LBL_ROLES_AND_PERMISSIONS,LBL_DELETE,LBL_VIEW,LBL_MODIFY,LBL_ARE_YOU_SURE_DELETE_COMMON,LBL_CONFIRM_DELETE,LBL_BACK_TO_SETTINGS} from '../../configs/labelConfigs';  
import {URL_IMG} from '../../configs/urlConfigs';
import {MSG_ROLES_REQUIRED, MSG_ROLES_ADD_SUCCESS, MSG_ROLES_UPDATE_SUCCESS, MSG_ROLES_DELETE_SUCCESS, MSG_ROLES_PERMISSION_SUCCESS, MSG_ROLES_ADD_EDIT_DUPLICATE, MSG_ERROR, MSG_ROLE_DELETE_ERROR,MSG_DATA_SAVE_ERROR,MSG_SERVER_DATA_FETCH_ERROR, MSG_REQUIRED} from '../../configs/msgConfigs'; 
import {SUPER_ROLES_SETTINGS_PERMISSION_LEFT_ARR,SUPER_ROLES_SETTINGS_PERMISSION_RIGHT_ARR,ROUTE_REFRESH,ROUTE_AFFILIATE_REFRESH,LIST_TYPE, ADD_TYPE, EDIT_TYPE, UPDATE_TYPE,DELETE_TYPE,LOGIN_SUPER_ADMIN_GROUP,LOGIN_AFFILIATE_GROUP,ROLES_PERMISSION_LEFT_ARR,ROLES_PERMISSION_RIGHT_ARR,VIEW_ONLY_ARR,MODIFY_ONLY_ARR,SUPER_ROLES_PERMISSION_LEFT_ARR,SUPER_ROLES_PERMISSION_RIGHT_ARR,ROLES_SETTINGS_PERMISSION_LEFT_ARR,ROLES_SETTINGS_PERMISSION_RIGHT_ARR} from '../../configs/staticConfigs';



class RolesPermissionComponent extends Component { 
    
    constructor(props){
        super(props)

        this.state = {
            rolesList: [],
            permissionsList: [],
            permissionsEditListCol1: [],
            permissionsEditListCol2: [],
            settingsEditListCol1: [],
            settingsEditListCol2: [],
            permissionsEditFullList: [],
            pEditRowsCol1: 0,
            pEditRowsCol2: 0, 
            rolesListStatus: 0,
            rolesStatusText: '', 
            dropdownExpanded: false,
            activeRowId:0,            
            formErrors:{
                roleName: ''            
            },   
            rolesData:{
                roleId: 0,
                roleName: '',
                rolePermissions: []
            },
            editMode:false,
            sortField: 'id',
            sortOrder: '',
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
            deleteFieldName: '', 
            modalOpened: '',
            editRoleId: 0, 
            roleName: '', 
            editPermissions: [], 
            pageLoaded: 0,
            roleNameFormError: '', 
            selRoleNameFormError: MSG_ROLES_REQUIRED,
            objViewModify: {},
            permType: {},
            isAdmin: false
        }

        this.openModal = this.openModal.bind(this);
        this.onSaveFormData = this.onSaveFormData.bind(this);
        this.onSavePermissionData = this.onSavePermissionData.bind(this); 
        this.onModalFormReset = this.onModalFormReset.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        this.onSort = this.onSort.bind(this);
        this.setModalOpened = this.setModalOpened.bind(this); 
        this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this); 
        this.openPermissionModal = this.openPermissionModal.bind(this); 
        this.modalDelete = React.createRef();
        this.modal = React.createRef();
        this.modalPermission = React.createRef();
    }

    componentDidMount() {
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
            this.setState({isAdmin:false});
        }else{
            this.setState({isAdmin:true});
        }  
        document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+" - "+LBL_ROLES_AND_PERMISSIONS;
        this.props.rolesListAction();   
    }

    onSort = (sortKey) =>{    
        let sOrder = '';
        let tmpObj = [...this.state.rolesList];
        if(this.state.sortField===sortKey){         
            if(this.state.sortOrder==='' || this.state.sortOrder==='desc') {
                sOrder = 'asc';
                tmpObj.sort((a,b) => a.name.localeCompare(b.name));
            }
            else if(this.state.sortOrder==='asc') {
                sOrder = 'desc';
                tmpObj.sort((a,b) => b.name.localeCompare(a.name));
            }
            this.setState({ rolesList:tmpObj, sortField:sortKey, sortOrder:sOrder });            
        }else{
            sOrder = 'asc';
            tmpObj.sort((a,b) => a.name.localeCompare(b.name));
            this.setState({ rolesList:tmpObj, sortField:sortKey, sortOrder:sOrder });          
        }        
    }

    onHandleChange = (event) =>{        
        const {name, value} = event.target;
        let roleNameFormError = this.state.roleNameFormError;
        switch(name){
            case 'roleName':
                roleNameFormError = value.trim().length <=0 ? MSG_ROLES_REQUIRED : ""; 
                break;       
            case 'selPermissions':
                let errMsg = ''; 
                
                if(value==='0~~~~') {
                    errMsg = MSG_ROLES_REQUIRED; 
                }
                let listObj = value.split('~~'); // this.props.rolesList; 
                let tmpEId = parseInt(listObj[0],10); 
                let tmpEName = listObj[1]; 
                let tmpEPerm = []; 
                listObj[2].split(',').map( (pid) => (parseInt(pid,10)) && tmpEPerm.push(parseInt(pid,10))); 
                this.setState({editRoleId:tmpEId, roleName:tmpEName, editPermissions:tmpEPerm,selRoleNameFormError:errMsg}); 
                break;      
                         
            default : break;
        }
        let roleName   = value;
        this.setState({roleNameFormError,roleName});
    } 

    onSavePermissionData = (roleId) => { 
        this.setState({toastAction:true});  
        let rName = this.state.roleName
        if(rName==='') {
            this.setState({roleNameFormError:MSG_ROLES_REQUIRED});
        }                    
        else if(roleId){
            let foundRole = 0; 
            this.state.rolesList.map((rObj) => {
                if(roleId!==rObj.id && rObj.name===rName.toLowerCase()) {
                    foundRole = 1; 
                }
                return console.log('.'); 
            }); 
            if(foundRole > 0) {
                this.setState({roleNameFormError:MSG_ROLES_ADD_EDIT_DUPLICATE});
            }else{
                let permissionsArr = this.state.editPermissions;
                let {permType, objViewModify} = this.state;
                for(var i in objViewModify){
                    if(objViewModify[i].length == 2){
                        if(permissionsArr.indexOf(objViewModify[i][0]) != -1 && permissionsArr.indexOf(objViewModify[i][1]) == -1 && permType[objViewModify[i][0]] == 'modify'){
                            permissionsArr.push(objViewModify[i][1]);
                        }else if(permissionsArr.indexOf(objViewModify[i][1]) != -1 && permissionsArr.indexOf(objViewModify[i][0]) == -1 && permType[objViewModify[i][1]] == 'modify'){
                            permissionsArr.push(objViewModify[i][0]);
                        }
                    }
                }
                let rolesData= {
                    id: this.state.editRoleId, 
                    name: this.state.roleName,   
                    permissions: permissionsArr      
                } 

                // console.log('SavePermission '+JSON.stringify(rolesData)); 
                this.props.rolesPermissionUpdateAction(rolesData); 
                this.onModalFormReset(); 
                this.modalPermission.current.handleModelClose(); 
            }
            
        }else{
            let permissionsArr = this.state.editPermissions;
            let {permType, objViewModify} = this.state;
            for(var i in objViewModify){
                if(objViewModify[i].length == 2){
                    if(permissionsArr.indexOf(objViewModify[i][0]) != -1 && permissionsArr.indexOf(objViewModify[i][1]) == -1 && permType[objViewModify[i][0]] == 'modify'){
                        permissionsArr.push(objViewModify[i][1]);
                    }else if(permissionsArr.indexOf(objViewModify[i][1]) != -1 && permissionsArr.indexOf(objViewModify[i][0]) == -1 && permType[objViewModify[i][1]] == 'modify'){
                        permissionsArr.push(objViewModify[i][0]);
                    }
                }
            }
            let rolesData= {
                name: this.state.roleName,                      
                permissions: permissionsArr                      
            } 
            this.props.rolesAddAction(rolesData); 
            this.onModalFormReset(); 
            this.modalPermission.current.handleModelClose(); 
        }    
    }

    onSaveFormData = (editRoleId) =>{
        if(formValid(this.state)){
            this.setState({toastAction:true});      
            let rName = this.state.rolesData.roleName.trim();                 
            if(editRoleId){
                if(rName==='') {
                    this.setState({roleNameFormError:MSG_ROLES_REQUIRED});
                }
                else {
                    let foundRole = 0; 
                    this.state.rolesList.map((rObj) => {
                        if(editRoleId!==rObj.id && rObj.name===rName.toLowerCase()) {
                            foundRole = 1; 
                        }
                        return console.log('.'); 
                    }); 
                    if(foundRole > 0) {
                        this.setState({roleNameFormError:MSG_ROLES_ADD_EDIT_DUPLICATE});
                    }
                    else {
                        let rolesData= {
                            id:editRoleId,
                            name: this.state.rolesData.roleName.trim(),   
                            permissions: this.state.rolesData.rolePermissions                
                        } 
                        this.props.rolesUpdateAction(rolesData); 
                        this.onModalFormReset();
                        this.modal.current.handleModelClose();
                    }
                }
            }else{
                if(rName==='') {
                    this.setState({roleNameFormError:MSG_ROLES_REQUIRED});
                }
                else {
                    let foundRole = 0; 
                    this.state.rolesList.map((rObj) => {
                        if(rObj.name===rName.toLowerCase()) {
                            foundRole = 1; 
                        } 
                        return console.log('.'); 
                    }) 
                    if(foundRole > 0) {
                        this.setState({roleNameFormError:MSG_ROLES_ADD_EDIT_DUPLICATE});
                    }
                    else {
                        let rolesData= {
                            name: this.state.rolesData.roleName,                      
                        } 
                        this.props.rolesAddAction(rolesData); 
                        this.onModalFormReset();
                        this.modal.current.handleModelClose();
                    }
                }                
            }    
        }else{
            let roleNameFormError = this.state.roleNameFormError;
            if(this.state.rolesData.roleName===''){
                roleNameFormError = MSG_ROLES_REQUIRED; 
            }            
            this.setState({roleNameFormError});
        }
    }

    setModalOpened(modalType) {
        // console.log(modalType); 
        this.setState({modalOpened:modalType}); 
    }

    handleChangeCheckbox(colNum,pId,viewName,type,e) {
        // let tmpListObj = this.state.rolesList; 
        let tmpEditPerm = this.state.editPermissions; 
        let {objViewModify} = this.state; 
        // console.log('tmpEditPerm: '+tmpEditPerm); 
        let index = objViewModify[viewName].indexOf(pId)
        let viewIndex = 0;
        if(type == 'modify' && objViewModify[viewName].length == 2){
            
            if(index == 0){
                viewIndex = 1;
            }
            let viewPId = objViewModify[viewName][viewIndex];
            if(e.target.checked && tmpEditPerm.indexOf(viewPId) < 0){
                tmpEditPerm.push(viewPId);
            }  
        }else if(type == 'view' && objViewModify[viewName].length == 2){
            if(index == 0){
                viewIndex = 1;
            }
            let viewPId = objViewModify[viewName][viewIndex];
            if(!e.target.checked && tmpEditPerm.indexOf(viewPId) != -1){
                // tmpEditPerm.pop(viewPId);
                tmpEditPerm = tmpEditPerm.filter(item => item !== viewPId)
            }  
        }
        if(viewName == 'settings'){
            if(!this.state.isAdmin){
                if(e.target.checked){
                ROLES_SETTINGS_PERMISSION_LEFT_ARR.map((name,index)=>{
                    if(tmpEditPerm.indexOf(objViewModify[name][0]) === -1){
                        tmpEditPerm.push(objViewModify[name][0])
                    }
                })
                ROLES_SETTINGS_PERMISSION_RIGHT_ARR.map((name,index)=>{
                    if(tmpEditPerm.indexOf(objViewModify[name][0]) === -1){
                        tmpEditPerm.push(objViewModify[name][0])
                    }
                })
                }else{
                    ROLES_SETTINGS_PERMISSION_LEFT_ARR.map((name,index)=>{
                        if(tmpEditPerm.indexOf(objViewModify[name][0]) !== -1){
                            
                            tmpEditPerm.splice(tmpEditPerm.indexOf(objViewModify[name][0]),1)
                        }
                    })
                    ROLES_SETTINGS_PERMISSION_RIGHT_ARR.map((name,index)=>{
                        if(tmpEditPerm.indexOf(objViewModify[name][0]) !== -1){
                            tmpEditPerm.splice(tmpEditPerm.indexOf(objViewModify[name][0]),1)
                        }
                    })
                }
            }else{
                if(e.target.checked){
                    SUPER_ROLES_SETTINGS_PERMISSION_LEFT_ARR.map((name,index)=>{
                        if(tmpEditPerm.indexOf(objViewModify[name][0]) === -1){
                            tmpEditPerm.push(objViewModify[name][0])
                        }
                    })
                    SUPER_ROLES_SETTINGS_PERMISSION_RIGHT_ARR.map((name,index)=>{
                        if(tmpEditPerm.indexOf(objViewModify[name][0]) === -1){
                            tmpEditPerm.push(objViewModify[name][0])
                        }
                    })
                }else{
                    SUPER_ROLES_SETTINGS_PERMISSION_LEFT_ARR.map((name,index)=>{
                        if(tmpEditPerm.indexOf(objViewModify[name][0]) !== -1){
                            
                            tmpEditPerm.splice(tmpEditPerm.indexOf(objViewModify[name][0]),1)
                        }
                    })
                    SUPER_ROLES_SETTINGS_PERMISSION_RIGHT_ARR.map((name,index)=>{
                        if(tmpEditPerm.indexOf(objViewModify[name][0]) !== -1){
                            tmpEditPerm.splice(tmpEditPerm.indexOf(objViewModify[name][0]),1)
                        }
                    })
                }
            }
        }
        if(e.target.checked && tmpEditPerm.indexOf(pId) < 0) tmpEditPerm.push(pId);
        else tmpEditPerm = tmpEditPerm.filter(item => item !== pId);
        if(!this.state.isAdmin){
            if((ROLES_SETTINGS_PERMISSION_LEFT_ARR.indexOf(viewName) !== -1 || 
                        ROLES_SETTINGS_PERMISSION_RIGHT_ARR.indexOf(viewName !== -1))&& !e.target.checked){
            let flag = false;
            ROLES_SETTINGS_PERMISSION_LEFT_ARR.map((item,index)=>{
                if(tmpEditPerm.indexOf(objViewModify[item][0]) !== -1){
                    flag = true;
                    return true
                }
            })
            if(!flag){
                  ROLES_SETTINGS_PERMISSION_RIGHT_ARR.map((item,index)=>{
                    if(tmpEditPerm.indexOf(objViewModify[item][0]) !== -1){
                        flag = true;
                        return true
                    }
                })  
            }
            if(!flag && tmpEditPerm.indexOf(objViewModify['settings'][0]) !== -1){
                tmpEditPerm.splice(tmpEditPerm.indexOf(objViewModify['settings'][0]),1)
            }

            }else if((ROLES_SETTINGS_PERMISSION_LEFT_ARR.indexOf(viewName) !== -1 || 
                            ROLES_SETTINGS_PERMISSION_RIGHT_ARR.indexOf( viewName) !== -1) &&
                            e.target.checked && 
                            tmpEditPerm.indexOf(objViewModify['settings'][0]) === -1){

                tmpEditPerm.push(objViewModify['settings'][0])
            }
        }else{
            if((SUPER_ROLES_SETTINGS_PERMISSION_LEFT_ARR.indexOf(viewName) !== -1 || 
                        SUPER_ROLES_SETTINGS_PERMISSION_RIGHT_ARR.indexOf(viewName !== -1))&& !e.target.checked){
            let flag = false;
            SUPER_ROLES_SETTINGS_PERMISSION_LEFT_ARR.map((item,index)=>{
                if(tmpEditPerm.indexOf(objViewModify[item][0]) !== -1){
                    flag = true;
                    return true
                }
            })
            if(!flag){
                  SUPER_ROLES_SETTINGS_PERMISSION_RIGHT_ARR.map((item,index)=>{
                    if(tmpEditPerm.indexOf(objViewModify[item][0]) !== -1){
                        flag = true;
                        return true
                    }
                })  
            }
            if(!flag && tmpEditPerm.indexOf(objViewModify['settings'][0]) !== -1){
                tmpEditPerm.splice(tmpEditPerm.indexOf(objViewModify['settings'][0]),1)
            }

            }else if((SUPER_ROLES_SETTINGS_PERMISSION_LEFT_ARR.indexOf(viewName) !== -1 || 
                            SUPER_ROLES_SETTINGS_PERMISSION_RIGHT_ARR.indexOf( viewName) !== -1) &&
                            e.target.checked && 
                            tmpEditPerm.indexOf(objViewModify['settings'][0]) === -1){

                tmpEditPerm.push(objViewModify['settings'][0])
            }
        }
        
        this.setState({editPermissions:tmpEditPerm}, () => {
            console.log(this.state.editPermissions)
            // console.log('ChangCHk: EditRoleId: '+this.state.editRoleId+', editRoleName: '+this.state.editRoleName+' editPermissions: '+JSON.stringify(this.state.editPermissions)); 
        }); 
        // this.setState({rolesList:tmpListObj}); 
    }

    openModal(e) {  
        switch(e.target.dataset.toggle){
            case 'modal':   this.setState({modalOpened:'roleModal'}); 
                            this.modal.current.handleOpenModal(); 
                            break; 
            case 'modalPermission': 
                            let tmpObj = {id:0, name:'', permissions:[]};
                            this.setState({selRoleNameFormError:MSG_ROLES_REQUIRED}); 
                            this.openPermissionModal(tmpObj);  
                            break; 
            default: return;
        }
    }  

    openPermissionModal(roleObj) {
        this.setState({editRoleId:roleObj.id}); 
        //console.log('openPermissionModal: '+JSON.stringify(roleObj)); 
        let editListCol1 = []; 
        let editListCol2 = [];
        let settingsListCol1 = []; 
        let settingsListCol2 = []; 
        let tmpEditObj = {}; 
        let pNamesObj = [...new Set(this.state.permissionsList.map(item => item.name))];
        let copyObj = this.state.permissionsList;
        let totRows = pNamesObj.length; 
        let col1 = (totRows%2) ? ((totRows/2)+1) : (totRows/2); 
        let col2 = totRows-col1; 
        let tmpRowCnt = 0;
        let objViewModify = {} 
        let permType = {} 
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }
        console.log(pNamesObj)
        pNamesObj.map(function(item) {
            tmpRowCnt++; 
            tmpEditObj = {
                pName: item,
                viewId: 0,
                viewCode: '',
                viewName: '',
                viewChecked: false,
                modifyId: 0,
                modifyCode: '',
                modifyChecked: false,
                sortIndex:null
            };
            let viewName = ''; 
            copyObj.filter(pItem => pItem.name.includes(item)).map(function(eachItem) {
                let arrCode = eachItem.codename.split('_');
                if(arrCode[2] in objViewModify && objViewModify[arrCode[2]].indexOf(eachItem.id) != -1){
                    return console.log('.'); 
                } 
                if(arrCode[3]==='view' && MODIFY_ONLY_ARR.indexOf(arrCode[2])==-1) {
                    console.log(arrCode[2])
                    tmpEditObj.viewId = eachItem.id;
                    tmpEditObj.viewCode = eachItem.codename;
                    tmpEditObj.viewName = arrCode[2];
                    tmpEditObj.pName = LBL_ROLE_PERMISSIONS_SETTINGS[arrCode[2]];
                    viewName = arrCode[2];
                    permType[eachItem.id] = 'view';
                    if(arrCode[2] in objViewModify){
                       objViewModify[arrCode[2]].push(eachItem.id);
                    }else{
                        objViewModify[arrCode[2]] = [eachItem.id];
                    }
                }
                else if(arrCode[3]==='modify' && VIEW_ONLY_ARR.indexOf(arrCode[2])==-1) {
                    tmpEditObj.modifyId = eachItem.id;
                    tmpEditObj.modifyCode = eachItem.codename;
                    tmpEditObj.viewName = arrCode[2];
                    tmpEditObj.pName = LBL_ROLE_PERMISSIONS_SETTINGS[arrCode[2]];
                    viewName = arrCode[2];
                    permType[eachItem.id] = 'modify';
                    if(arrCode[2] in objViewModify){
                       objViewModify[arrCode[2]].push(eachItem.id);
                    }else{
                        objViewModify[arrCode[2]] = [eachItem.id];
                    }
                }
                return console.log('.'); 
            })
            
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                if(ROLES_PERMISSION_RIGHT_ARR.indexOf(viewName) != -1){
                let rightIndex = ROLES_PERMISSION_RIGHT_ARR.indexOf(viewName);
                tmpEditObj.sortIndex = rightIndex
                editListCol2.push(tmpEditObj);

                }else if(ROLES_PERMISSION_LEFT_ARR.indexOf(viewName)  != -1 ){
                    let leftIndex = ROLES_PERMISSION_LEFT_ARR.indexOf(viewName);
                    tmpEditObj.sortIndex = leftIndex
                    editListCol1.push(tmpEditObj); 
                }else if(ROLES_SETTINGS_PERMISSION_LEFT_ARR.indexOf(viewName) != -1){
                    let leftIndex = ROLES_SETTINGS_PERMISSION_LEFT_ARR.indexOf(viewName);
                    tmpEditObj.sortIndex = leftIndex
                    settingsListCol1.push(tmpEditObj);
                }else if(ROLES_SETTINGS_PERMISSION_RIGHT_ARR.indexOf(viewName) != -1){
                    let leftIndex = ROLES_SETTINGS_PERMISSION_RIGHT_ARR.indexOf(viewName);
                    tmpEditObj.sortIndex = leftIndex
                    settingsListCol2.push(tmpEditObj);
                }
            }else{
                if(SUPER_ROLES_PERMISSION_RIGHT_ARR.indexOf(viewName) != -1){
                let rightIndex = SUPER_ROLES_PERMISSION_RIGHT_ARR.indexOf(viewName);
                tmpEditObj.sortIndex = rightIndex
                editListCol2.push(tmpEditObj);

                }else if(SUPER_ROLES_PERMISSION_LEFT_ARR.indexOf(viewName)  != -1 ){
                    let leftIndex = SUPER_ROLES_PERMISSION_LEFT_ARR.indexOf(viewName);
                    tmpEditObj.sortIndex = leftIndex
                    editListCol1.push(tmpEditObj); 
                }else if(SUPER_ROLES_SETTINGS_PERMISSION_LEFT_ARR.indexOf(viewName)  != -1 ){
                    let leftIndex = SUPER_ROLES_SETTINGS_PERMISSION_LEFT_ARR.indexOf(viewName);
                    tmpEditObj.sortIndex = leftIndex
                    settingsListCol1.push(tmpEditObj); 
                }else if(SUPER_ROLES_SETTINGS_PERMISSION_RIGHT_ARR.indexOf(viewName)  != -1 ){
                    let leftIndex = SUPER_ROLES_SETTINGS_PERMISSION_RIGHT_ARR.indexOf(viewName);
                    tmpEditObj.sortIndex = leftIndex
                    settingsListCol2.push(tmpEditObj); 
                }
            }
            
            return console.log('.');
        });

        // console.log(editListCol1);
        editListCol1.sort((a, b) => (a.sortIndex > b.sortIndex) ? 1 : -1);
        editListCol2.sort((a, b) => (a.sortIndex > b.sortIndex) ? 1 : -1);
        settingsListCol1.sort((a, b) => (a.sortIndex > b.sortIndex) ? 1 : -1);
        settingsListCol2.sort((a, b) => (a.sortIndex > b.sortIndex) ? 1 : -1);
        // console.log('tmpEditList: '+JSON.stringify(editListCol1)); 
        let tmpId = roleObj.id; // this.state.rolesList[0].id; 
        let tmpName = roleObj.name; // this.state.rolesList[0].name; 
        let tmpPerm = roleObj.permissions; // this.state.rolesList[0].permissions; 
        
        //console.log('editRoleId22: '+tmpId+', editRoleName:'+tmpName+', editPermissions'+JSON.stringify(tmpPerm));
        // 
        this.setState({settingsEditListCol1:settingsListCol1,settingsEditListCol2:settingsListCol2,editRoleId:tmpId, objViewModify:objViewModify,permType:permType,roleName:tmpName, editPermissions:tmpPerm, permissionsEditListCol1:editListCol1, permissionsEditListCol2:editListCol2, pEditRowsCol1:col1, pEditRowsCol2:col2, modalOpened:'roleModal', selRoleNameFormError:parseInt(tmpId,10)?'':MSG_ROLES_REQUIRED}, () => {
            this.modalPermission.current.handleOpenModal();
            //console.log('EditRoleOpen: EditRoleId: '+this.state.editRoleId+', editRoleName: '+this.state.editRoleName+' editPermissions: '+JSON.stringify(this.state.editPermissions)); 
        });
    }

    onModalFormReset = () =>{   
        let rolesDet   = this.state.rolesData;     
        rolesDet.roleId = 0;
        rolesDet.roleName = '';  
        rolesDet.rolePermissions = [];        
        this.setState({roleNameFormError:'', rolesData:rolesDet, editRoleId:0, roleName:'', editPermissions:[], deleteFieldName: ''}); 
        this.props.clearAction();  
    }

    onShowActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');      

        if(this.state.activeRowId===0){   
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus();
        }
        else if(this.state.activeRowId===rowId){ 
            this.setState({activeRowId:0}); 
        }
        else if(this.state.activeRowId!==rowId){   
            dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus();
        }        
    } 

    onHideActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({activeRowId:0});
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    }  

    editBtnClick = (item) =>{  
        let roleNameFormError = this.state.roleNameFormError;
        roleNameFormError = '';
        let roleDet = this.state.rolesData;
        roleDet.roleId = item.id;
        roleDet.roleName = titleCase(item.name);
        roleDet.rolePermissions = item.permissions; 
        this.setState({roleNameFormError:roleNameFormError,rolesData:roleDet,editRoleId:item.id});
        // console.log('rolesData: '+JSON.stringify(this.state.rolesData)); 
        this.modal.current.handleOpenModal();
        // this.props.sectorEditAction(rowId);
        setTimeout(()=> {
            if(document.getElementById('roleName')) {
                document.getElementById('roleName').focus(); 
            }
        }, 500); 
        
    }

    deleteBtnClick = (rowId,itemName) =>{
        //console.log('rowId: '+rowId+', itemName: '+itemName); 
        this.setState({
            rolesData: {
                roleId: rowId
            }, deleteFieldName: itemName
        }, () => { this.modalDelete.current.handleOpenModal() }); 
    }

    onDeleteAction = () =>{
        let roleId = this.state.rolesData.roleId;
        this.props.rolesDeleteAction(roleId); 
        this.modalDelete.current.handleModelClose();              
    }

    componentDidUpdate(prevProps) {       
        // MSG_ROLES_PERMISSION_SUCCESS 
        // console.log('this.props: '+this.props.activity); 
        const { errorData } = this.props;
        if(this.props.status===401 || this.props.status===403){
            return <Redirect to={ROUTE_REFRESH} />;
        }

        if (this.state.pageLoaded===0 || this.props.activity !== prevProps.activity || this.props.status !== prevProps.status) {
            if(this.props.activity===LIST_TYPE){
                if(this.props.status===200){
                    this.setState({pageLoaded:1,rolesList:this.props.rolesList, permissionsList:this.props.permissionsList}, () => {
                        if(this.state.sortField==='id' && this.state.sortOrder==='') this.onSort('name'); 
                     });
                }  
                else {
                    //let toastErrMsg = MSG_ERROR+' '+JSON.stringify(errorData); 
                    this.setState({pageLoaded:1,toastFlag:true,toastMessage:MSG_SERVER_DATA_FETCH_ERROR,toastSuccess:false});
                    setTimeout(()=> {
                        this.onCloseToast();
                    }, 5000); 
                }
            } else if(this.props.activity===ADD_TYPE){
                if(this.props.status===200){
                    this.props.rolesListAction();
                    this.setState({pageLoaded:1,toastFlag:true,toastMessage:MSG_ROLES_ADD_SUCCESS,toastSuccess:true});
                    setTimeout(()=> {
                        this.onCloseToast();
                    }, 3000);
                }
                else {
                    let toastErrMsg = MSG_ERROR+' '+JSON.stringify(errorData); 
                    this.setState({pageLoaded:1,toastFlag:true,toastMessage:MSG_DATA_SAVE_ERROR,toastSuccess:false});
                    setTimeout(()=> {
                        this.onCloseToast();
                    }, 5000);
                }
            }else if(this.props.activity===EDIT_TYPE){
                if(this.props.status===200){
                    this.props.rolesListAction();
                    this.setState({pageLoaded:1,toastFlag:true,toastMessage:MSG_ROLES_UPDATE_SUCCESS,toastSuccess:true});
                    setTimeout(()=> {
                        this.onCloseToast();
                    }, 3000);   
                }
                else {
                    let toastErrMsg = MSG_ERROR+' '+JSON.stringify(errorData); 
                    this.setState({pageLoaded:1,toastFlag:true,toastMessage:MSG_DATA_SAVE_ERROR,toastSuccess:false});
                    setTimeout(()=> {
                        this.onCloseToast();
                    }, 5000);
                }       
            }else if(this.props.activity===DELETE_TYPE){
                if(this.props.status===200){
                    this.props.rolesListAction();
                    this.setState({pageLoaded:1,toastFlag:true,toastMessage:MSG_ROLES_DELETE_SUCCESS,toastSuccess:true});
                    setTimeout(()=> {
                        this.onCloseToast();
                    }, 3000);
                }
                else if(this.props.status===424){ 
                    this.setState({pageLoaded:1,toastFlag:true,toastMessage:MSG_ROLE_DELETE_ERROR,toastSuccess:false});
                    setTimeout(()=> {
                        this.onCloseToast();
                    }, 5000); 
                }
                else {
                    let toastErrMsg = MSG_ERROR+' '+JSON.stringify(errorData); 
                    this.setState({pageLoaded:1,toastFlag:true,toastMessage:MSG_DATA_SAVE_ERROR,toastSuccess:false});
                    setTimeout(()=> {
                        this.onCloseToast();
                    }, 5000);
                }       
            }else if(this.props.activity===UPDATE_TYPE){
                if(this.props.status===200){
                    this.props.rolesListAction();
                    this.setState({pageLoaded:1,toastFlag:true,toastMessage:MSG_ROLES_PERMISSION_SUCCESS,toastSuccess:true});
                    setTimeout(()=> {
                        this.onCloseToast();
                    }, 3000);     
                }
                else {
                    let toastErrMsg = MSG_ERROR+' '+JSON.stringify(errorData); 
                    this.setState({pageLoaded:1,toastFlag:true,toastMessage:MSG_DATA_SAVE_ERROR,toastSuccess:false});
                    setTimeout(()=> {
                        this.onCloseToast();
                    }, 5000);
                }        
            }else{
                // console.log('error');    
            }
        }
    }

    render(){
        const {
            toastMessage,toastFlag,toastSuccess,sortField,sortOrder,              
        } = this.state

        // const { rolesList,role} = this.props;    
        // console.log('this.props.status: '+this.props.status);
        const { status} = this.props;  
        
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }

        if(status===401 || status===403){
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
            }else{
                return <Redirect to={ROUTE_REFRESH} />;

            }
        }
        let rolesList = [];
        if(userGroup === LOGIN_SUPER_ADMIN_GROUP && this.state.rolesList){
            rolesList = this.state.rolesList.filter(item => item.name != 'admin')
        }else{
            rolesList = this.state.rolesList
        }

        let chkCnt = 0; 
        let chkField = ''; 
        let chkField22 = ''; 

        return(
            <div className="col-md-8">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="box">
                    <div className="box-head">
                        <div className='divFloatLeft padding-left-20 padding-top-5 font-14'><Link to={userGroup===LOGIN_AFFILIATE_GROUP ? ROUTE_AFFILIATE_SETTINGS : ROUTE_SA_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link> </div>
                        <div className="to-right">             
                            {/*<button className="btn btn-primary launch-modal" onClick={this.openModal.bind(this)} data-target="#addNew-role" data-toggle="modal">Add {LBL_ROLE}</button>*/}
                            <button className="btn btn-primary launch-modal" onClick={this.openModal.bind(this)} data-target="#addNew-permissions" data-toggle="modalPermission">Add {LBL_ROLE}</button> 
                            {/* <button className="btn btn-primary launch-modal" onClick={this.openModal.bind(this)} data-target="#addNew-permissions" data-toggle="modalPermission">{LBL_SET_PERMISSIONS}</button> */}
                        </div>
                    </div> 
                    <div className="box-content">
                        <div className="table-responsive">
                            <table id="data-table" className="table" style={{width:"100%"}}>
                                <thead>
                                    <tr>
                                    <th className="text-left">{LBL_SLNUM}</th>
                                    <th onClick={(e) => this.onSort('name')} className="spanPointer">{LBL_ROLES} <i className={sortField=='name' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                    <th>{LBL_ACTIONS}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { rolesList && rolesList.map((item,itemIndex) => {

                                        return (
                                            <tr key={item.id}>
                                                <td className="text-left">{itemIndex+1}</td>
                                                <td>{titleCase(item.name)}</td>
                                                <td>
                                                    <div className="dropdown" id={'dropdown-'+item.id}>
                                                        <button className="dropdown-toggle" type="button"
                                                            id={'dropdownMenuButton-'+item.id} data-toggle="dropdown" aria-haspopup="true" aria-expanded={this.state.dropdownExpanded} onClick={(e) => this.onShowActionButtons(e, item.id)} >
                                                            <input type="image" id={"img-action-"+item.id} src={require('../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                        </button>
                                                        <div className="dropdown-menu" id={'dropdown-menu-'+item.id} aria-labelledby="dropdownMenuButton">
                                                            <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.openPermissionModal(item)}>Edit</Link>  
                                                            {/*<Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.openPermissionModal(item)}>{LBL_SET_PERMISSIONS}</Link>*/}
                                                            <Link className="dropdown-item delete"
                                                                to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,(LBL_ROLE+' "'+titleCase(item.name)+'"'))}>{LBL_DELETE}</Link>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                {/*   
                                    if(item.name.toLowerCase().trim()==='admin') { 
                                        return (<tr key={item.id}>
                                            <td className="text-left">{itemIndex+1}</td>
                                            <td>{titleCase(item.name)} (Full Access)</td>
                                            <td></td>
                                        </tr>)
                                    }
                                    else {
                                        return (
                                            <tr key={item.id}>
                                                <td className="text-left">{itemIndex+1}</td>
                                                <td>{titleCase(item.name)}</td>
                                                <td>
                                                    <div className="dropdown" id={'dropdown-'+item.id}>
                                                        <button className="dropdown-toggle" type="button"
                                                            id={'dropdownMenuButton-'+item.id} data-toggle="dropdown" aria-haspopup="true" aria-expanded={this.state.dropdownExpanded} onClick={(e) => this.onShowActionButtons(e, item.id)}
                                                            onBlur={(e) => this.onHideActionButtons(e, item.id)}>
                                                            <img id={"img-"+item.id}  src={require('../../'+URL_IMG+'action.png')}  alt="Action" />
                                                        </button>
                                                        <div className="dropdown-menu" id={'dropdown-menu-'+item.id} aria-labelledby="dropdownMenuButton">
                                                            <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(item)}>Edit</Link>  
                                                            <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.openPermissionModal(item)}>{LBL_SET_PERMISSIONS}</Link>
                                                            <Link className="dropdown-item delete"
                                                                to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,(LBL_ROLE+' "'+titleCase(item.name)+'"'))}>Delete</Link>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    } */}
                                })} 
                                </tbody>
                            </table>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                        </div>
                    </div>
                </div>
                
                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset} >
                    {stringFormat(LBL_ARE_YOU_SURE_DELETE_COMMON,this.state.deleteFieldName)} 
                </ModalWindow>

                {/*<ModalWindow ref={this.modal} header={"User Role"} modalId={"addNew-role"}  saveFormData={ (e)=>this.onSaveFormData(this.state.editRoleId)} resetModalForm={this.onModalFormReset} type="save"  autoFocusField='roleName'  >
                    <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>{LBL_ROLE}</label>
                                    <div className="text-input">
                                    <input type="text" className={this.state.roleNameFormError.length >0 ? "input-error" : ''} name="roleName" id="roleName" onChange={this.onHandleChange} placeholder="" value={this.state.rolesData.roleName} maxLength={120} />
                                    {this.state.roleNameFormError.length >0 && this.state.roleNameFormError!=MSG_ROLES_REQUIRED && (
                                        <div className="text-red left-align text-12">{this.state.roleNameFormError}</div>
                                    )} 
                                    </div>
                                </div>
                            </div>
                    </div>
                </ModalWindow>*/}

                {/* editRoleId, editRoleName, editPermissions */}
                <ModalWindow ref={this.modalPermission} header={"User Role & Module Permissions"} modalId={"addNew-permissions"} saveFormData={ (e)=>this.onSavePermissionData(this.state.editRoleId)} resetModalForm={this.onModalFormReset} type="save" autoFocusField='selPermissions'>
                    <div className="row">
                        <div className="col-12">
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label>{LBL_ROLE}</label>
                                        <div className="text-input">
                                    <input type="text" className={this.state.roleNameFormError.length >0 ? "input-error" : ''} name="roleName" id="roleName" onChange={this.onHandleChange} placeholder="" value={this.state.roleName} maxLength={120} />
                                    {this.state.roleNameFormError.length >0 && this.state.roleNameFormError!=MSG_ROLES_REQUIRED && (
                                        <div className="text-red left-align text-12">{this.state.roleNameFormError}</div>
                                    )} 
                                    </div>
                                    </div>
                                </div>
                            </div>

                            {/* this.state..data.length) && (pEditRowsCol1) , , pEditRowsCol2 */}
                                     
                            <div className="row">
                            
                                <div className="col-6">
                                    <div className="row">
                                        <div className="col-6"></div>
                                        <div className="col-6">
                                            <div className="row">
                                                {<div className="col-6 text-center"><label>{LBL_VIEW}</label></div>}
                                                <div className="col-6 text-center"><label>{LBL_MODIFY}</label></div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* "pName":"associate users","viewId":142,"viewCode":"omnu_superadmin_associateusers_view","viewChecked":0,"modifyId":0,"modifyCode":"","modifyChecked":0 */}
                                    
                                    { this.state.permissionsEditListCol1.map((item) => {
                                        chkCnt++; chkField   = 'chk_'+chkCnt; 
                                        chkCnt++; chkField22 = 'chk_'+chkCnt; 
                                        return <div className="row" key={item.pName}>
                                        <div className="col-6"><label>{item.pName}</label> </div>
                                        <div className="col-6">
                                            <div className="row">
                                                {/* this.state.rolesData. editRoleId, editRoleName, editPermissions */}
                                                
                                                {<div className="custom-checkbox col-6 text-center">
                                                {item.viewId > 0 && <input type="checkbox" id={chkField} checked={this.state.editPermissions.indexOf(item.viewId) >= 0 ? true : false} onChange={(event) => this.handleChangeCheckbox('col1',item.viewId,item.viewName,'view',event)} /> } <label className="checkbox" htmlFor={chkField.toString()}></label></div>
                                                  }
                                                <div className="custom-checkbox col-6 text-center">
                                                { item.modifyId > 0 && <input type="checkbox" id={chkField22} checked={this.state.editPermissions.indexOf(item.modifyId) >= 0 ? true : false} onChange={(event) => this.handleChangeCheckbox('col1',item.modifyId,item.viewName,'modify',event)} />} <label className="checkbox" htmlFor={chkField22.toString()}></label>
                                                 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    } ) }
                                </div>
                                

                                <div className="col-6">
                                    <div className="row">
                                        <div className="col-6"></div>
                                        <div className="col-6">
                                            <div className="row">
                                                {<div className="col-6 text-center"><label>{LBL_VIEW}</label></div>}
                                                <div className="col-6 text-center"><label>{LBL_MODIFY}</label></div>
                                            </div>
                                        </div>
                                    </div>
                                    { this.state.permissionsEditListCol2.map((item) => {
                                        chkCnt++; chkField = 'chk_'+chkCnt; 
                                        chkCnt++; chkField22 = 'chk_'+chkCnt; 
                                        return <div className="row" key={item.pName}>
                                        <div className="col-6"><label>{item.pName}</label></div>
                                        <div className="col-6">
                                            <div className="row">
                                                
                                                {<div className="custom-checkbox col-6 text-center">{item.viewId > 0 && <input type="checkbox" id={chkField} checked={this.state.editPermissions.indexOf(item.viewId) >= 0 ? true : false} onChange={(event) => this.handleChangeCheckbox('col2',item.viewId,item.viewName,'view',event)} /> } <label className="checkbox" htmlFor={chkField.toString()}></label></div>

                                                }
                                                <div className="custom-checkbox col-6 text-center">{ item.modifyId > 0 && <input type="checkbox" id={chkField22} checked={this.state.editPermissions.indexOf(item.modifyId) >= 0 ? true : false}  onChange={(event) => this.handleChangeCheckbox('col2',item.modifyId,item.viewName,'modify',event)} /> } <label className="checkbox" htmlFor={chkField22.toString()}></label></div>
                                            </div>
                                        </div>   
                                    </div>
                                     } ) }
                                    
                                </div>
                            </div>
                            <div className="row">
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group">
                                            <label className="text-bold">{LBL_SETTINGS}</label>
                                            <div className="row">
                                                <div className="col-6">
                                                    <div className="row">
                                                        <div className="col-6"></div>
                                                        <div className="col-6">
                                                            <div className="row">
                                                                {<div className="col-6 text-center"><label>{LBL_VIEW}</label></div>}
                                                                {/*<div className="col-6 text-center"><label>{LBL_MODIFY}</label></div>*/}
                                                            </div>
                                                        </div>
                                                    </div>                                                
                                                    { this.state.settingsEditListCol1.map((item) => {
                                                        chkCnt++; chkField   = 'chk_'+chkCnt; 
                                                        chkCnt++; chkField22 = 'chk_'+chkCnt; 
                                                        return <div className="row" key={item.pName}>
                                                        <div className="col-6"><label>{item.pName}</label> </div>
                                                        <div className="col-6">
                                                            <div className="row">
                                                                {/* this.state.rolesData. editRoleId, editRoleName, editPermissions */}
                                                                
                                                                {<div className="custom-checkbox col-6 text-center">
                                                                {item.viewId > 0 && <input type="checkbox" id={chkField} checked={this.state.editPermissions.indexOf(item.viewId) >= 0 ? true : false} onChange={(event) => this.handleChangeCheckbox('col1',item.viewId,item.viewName,'view',event)} /> } <label className="checkbox" htmlFor={chkField.toString()}></label></div>
                                                                  }
                                                                {/*<div className="custom-checkbox col-6 text-center">
                                                                { item.modifyId > 0 && <input type="checkbox" id={chkField22} checked={this.state.editPermissions.indexOf(item.modifyId) >= 0 ? true : false} onChange={(event) => this.handleChangeCheckbox('col1',item.modifyId,item.viewName,'modify',event)} />} <label className="checkbox" htmlFor={chkField22.toString()}></label>
                                                                 
                                                                </div>*/}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    } ) }
                                                </div>
                                                

                                                <div className="col-6">
                                                    <div className="row">
                                                        <div className="col-6"></div>
                                                        <div className="col-6">
                                                            <div className="row">
                                                                {<div className="col-6 text-center"><label>{LBL_VIEW}</label></div>}
                                                                {/*<div className="col-6 text-center"><label>{LBL_MODIFY}</label></div>*/}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    { this.state.settingsEditListCol2.map((item) => {
                                                        chkCnt++; chkField = 'chk_'+chkCnt; 
                                                        chkCnt++; chkField22 = 'chk_'+chkCnt; 
                                                        return <div className="row" key={item.pName}>
                                                        <div className="col-6"><label>{item.pName}</label></div>
                                                        <div className="col-6">
                                                            <div className="row">
                                                                
                                                                {<div className="custom-checkbox col-6 text-center">{item.viewId > 0 && <input type="checkbox" id={chkField} checked={this.state.editPermissions.indexOf(item.viewId) >= 0 ? true : false} onChange={(event) => this.handleChangeCheckbox('col2',item.viewId,item.viewName,'view',event)} /> } <label className="checkbox" htmlFor={chkField.toString()}></label></div>

                                                                }
                                                                {/*<div className="custom-checkbox col-6 text-center">{ item.modifyId > 0 && <input type="checkbox" id={chkField22} checked={this.state.editPermissions.indexOf(item.modifyId) >= 0 ? true : false}  onChange={(event) => this.handleChangeCheckbox('col2',item.modifyId,item.viewName,'modify',event)} /> } <label className="checkbox" htmlFor={chkField22.toString()}></label></div>*/}
                                                            </div>
                                                        </div>   
                                                    </div>
                                                     } ) }
                                                    
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalWindow>

            </div>
        )
        
    }
    
}


const mapStateToProps = (response) => {
    // console.log('mapStateToProps: '+JSON.stringify(response.rolesPermission)); // VALUES FROM REDUCER 
    // this.state.rolesList = response.rolesPermission.rolesList;
    // console.log('mapStateToProps: '+JSON.stringify(response.rolesPermission.rolesList));
    return {
        rolesList: response.rolesPermission.rolesList,  
        permissionsList: response.rolesPermission.permissionsList,  
        status: response.rolesPermission.status,
        rolesStatusText: response.rolesPermission.statusText,
        activity: response.rolesPermission.activity,
        errorData: response.rolesPermission.errorData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        rolesListAction:data=>rolesListAction(data), 
        rolesAddAction:data=>rolesAddAction(data),
        //rolesEditAction:id=>rolesEditAction(id),
        rolesUpdateAction:data=>rolesUpdateAction(data),
        rolesDeleteAction:id=>rolesDeleteAction(id), 
        rolesPermissionEditAction:id=>rolesPermissionEditAction(id),
        rolesPermissionUpdateAction:data=>rolesPermissionUpdateAction(data),
        clearAction:clearAction
    },dispatch);  
}
export default connect(mapStateToProps,mapDispatchToProps)(RolesPermissionComponent);
